//Entry point

//Fix for IE10. Babel 6 stop support this version. This polyfill resolve it.
(function () {
  if (!(Object.setPrototypeOf || {}.__proto__)) {
    const nativeGetPrototypeOf = Object.getPrototypeOf;

    Object.getPrototypeOf = function (object) {
      if (object.__proto__) {
        return object.__proto__;
      } else {
        return nativeGetPrototypeOf.call(Object, object);
      }
    };
  }
})();

//Replace native .bind with this realization. Should be faster.
Function.prototype.bind = require('fast-bind');

require('css');
require('@babel/register');
require('../common/api/api.js');
require('../common/api/api.concepts.js');
require('../common/api/api.questionnaire.js');
require('./app.state.jsx');
require('./app.store.jsx');
require('./app.reducer.jsx');
require('./__react.app__.jsx');
